import Api from '../Api';

import { url } from './config';
import { IncomeType } from './types';

const api = new Api<IncomeType>(url);

export default api;
